import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Message from '@app/component/message/Message';
import TablePlaceholder from '@app/component/placeholder/TablePlaceholder';
import MarketStateService from '@app/model/market_state/service/MarketStateService';

const MarketStateProofPage = React.memo(() => {
	const { companyHotelId: companyHotelIdParam, proofChoiceId: proofChoiceIdParam } = useParams();
	const companyHotelId = Number(companyHotelIdParam);
	const proofChoiceId = Number(proofChoiceIdParam);
	const hasValidParameters = Number.isInteger(companyHotelId) && companyHotelId > 0 &&
		Number.isInteger(proofChoiceId) && proofChoiceId > 0;
	const [html, setHtml] = useState<string>();
	const [error, setError] = useState<string>();
	const [isLoading, setIsLoading] = useState(hasValidParameters);

	useEffect(() => {
		document.title = 'Rate proof | RoomPulse';
		if (!hasValidParameters) {
			setError('The proof link is invalid.');
			setIsLoading(false);
			return;
		}

		let isCurrentRequest = true;
		setHtml(undefined);
		setError(undefined);
		setIsLoading(true);
		MarketStateService.findMarketStateProof(companyHotelId, proofChoiceId)
			.then(proofHtml => {
				if (isCurrentRequest) setHtml(proofHtml);
			})
			.catch(() => {
				if (isCurrentRequest) setError('The proof is no longer available. It may have expired.');
			})
			.finally(() => {
				if (isCurrentRequest) setIsLoading(false);
			});

		return () => {
			isCurrentRequest = false;
		};
	}, [companyHotelId, hasValidParameters, proofChoiceId]);

	if (isLoading) return <main className="min-h-screen bg-white px-6 py-5"><TablePlaceholder /></main>;
	if (error !== undefined) return <main className="min-h-screen bg-gray-50 px-6 py-5">
		<Message state="warning">{error}</Message>
	</main>;

	return <iframe
		title="Booking rate proof"
		sandbox=""
		referrerPolicy="no-referrer"
		srcDoc={html}
		className="block h-dvh w-full border-0 bg-white"
	/>;
});

export default MarketStateProofPage;
